<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>角色列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索  新增-->
      <el-row :gutter="24">
        <el-col :span="10">
          <el-form
            :inline="true"
            :model="searchForm"
            :rules="searchRules"
            ref="searchForRef"
            label-width="80px"
            autocomplete="on"
            size="mini"
          >
            <el-form-item label="角色">
              <el-input v-model="searchForm.name" placeholder="请输入角色名称" type="text"></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-select
                v-model="searchForm.status"
                placeholder="请选择状态"
              >
                <el-option label="启用" :value="0"></el-option>
                <el-option label="禁用" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="1">
          <el-button type="success" size="mini" @click="searchSubmit()">搜索</el-button>
        </el-col>
        <el-col :span="1">
          <el-button type="primary" size="mini" @click="addData">新增</el-button>
        </el-col>
      </el-row>

      <!-- 表格 -->
      <el-table border
                :data="tableLoadData"
                style="width: 100%; margin-top:20px"
                row-key="id"
                :tree-props="{children: 'children'}"
                size="mini">
        <el-table-column prop="id" label="ID" width="180"></el-table-column>
        <el-table-column prop="name" label="角色名称" width="180"></el-table-column>
        <el-table-column label="是否超级管理员" >
          <template  slot-scope="scope">
            {{scope.row.is_root==1?'是':'否'}}
          </template>
        </el-table-column>
        <el-table-column prop="shop_name" label="所属商家" ></el-table-column>
        <el-table-column label="状态" width="180">
          <template slot-scope="scope">

            <el-switch
              :value="scope.row.status===1"
              disabled>
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" ></el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="300">
          <template  slot-scope="scope">
            <el-button type="warning" icon="el-icon-edit" size="mini" @click="handelEdit(scope.row)"> {{scope.row.level}}</el-button>
            <el-button type="danger" v-if="scope.row.is_root!=1" icon="el-icon-delete" size="mini"  @click="handelDel(scope.row)"> {{scope.row.level}}</el-button>
            <el-tooltip content="设置权限" placement="bottom" effect="dark">
              <el-button type="info" size="mini" icon="el-icon-folder-checked" @click="handelSelect(scope.row)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="550px">
      <el-form :model="form" :rules="rules" size="mini" ref="form" label-width="80px">
        <el-form-item label="角色名称" prop="name">
          <el-input v-model="form.name" autocomplete="off" clearable placeholder="请输入用户名"></el-input>
        </el-form-item>
<!--        <el-form-item label="商户名">-->
<!--          <el-input v-model="form.shop_name" autocomplete="off"></el-input>-->
<!--        </el-form-item>-->
        <el-form-item label="状态"  prop="status">
          <el-select
            v-model="form.status"
            placeholder="请选择状态"
          >
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" >
          <el-input v-model="form.remark" placeholder="请输入备注" type="text"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="reset_dialogForm('form')">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 设置权限弹框 -->
    <el-dialog :title="title" :visible.sync="powerDialogForm" width="550px">
      <el-form :model="powerForm" :rules="rulesPower" ref="form" label-width="80px">
        <el-form-item label="权限设置">
          <el-tree
            ref="tree"
            class="tenant_tree"
            :data="roleList"
            show-checkbox
            :props="defaultProps"
            default-expand-all
            node-key="id"
            highlight-current
            :check-strictly="true"
            @check-change="handleCheckChange"
            :default-checked-keys="defaultCateIds"
          >
          </el-tree>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="reset_powerForm('form')">取 消</el-button>
        <el-button type="primary" size="mini" @click="powerSubmitForm('form')">确 定</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
  export default {
    name: "proxyRoleList",
    components: {
    },
    props: {},
    data() {
      return {
        data: [{
          id: 1,
          label: '一级 1',
          children: [{
            id: 4,
            label: '二级 1-1',
            children: [{
              id: 9,
              label: '三级 1-1-1'
            }, {
              id: 10,
              label: '三级 1-1-2'
            }]
          }]
        }, {
          id: 2,
          label: '一级 2',
          children: [{
            id: 5,
            label: '二级 2-1'
          }, {
            id: 6,
            label: '二级 2-2'
          }]
        }, {
          id: 3,
          label: '一级 3',
          children: [{
            id: 7,
            label: '二级 3-1'
          }, {
            id: 8,
            label: '二级 3-2'
          }]
        }],
        defaultCateIds:[],
        // 搜索
        searchForm: {
          name: "",
          status: ""
        },
        searchRules: {
          name: [
            { required: true, message: "请输入角色名称", trigger: "blur" }
          ],
        },
        // 表头
        tableHeadConfig: [
          {
            label: "ID",
            field: "id"
          },
          {
            label: "角色",
            field: "name"
          },
          {
            label: "备注",
            field: "remark"
          },
          {
            label: "状态",
            columnType: "slot",
            slotName: "status",
          },
          {
            label: "操作",
            columnType: "slot",
            slotName: "operation",
            width: 200
          }
        ],
        // 数据
        tableLoadData: [],
        currentPage:1,// 当前页码
        pageSize:10,// 每页大小
        total:0,//总条目数
        id: '',
        rules: {
          name: [
            { required: true, message: '请输入角色', trigger: 'blur' },
            {
              min: 2,
              max: 5,
              message: "长度在 2 到 5 个字符",
              trigger: "blur",
            }
          ],
          status: [
            { required: true, message: '请选择状态', trigger: 'chance' }
          ],
          remark: [
            { required: true, message: '请输入职位', trigger: 'blur' }
          ],
        },
        dialogFormVisible: false,

        title: '',
        form: {
          title: '',
          corp_channel_id: '',
          corp_id: '',
          product_id: '',
          price: '',
          rate: '',
          real_price: '',
          status: '',
          remark: '',
          sell_price: '',
          desc: '',
          shop_name:'',
          shop_id:'',
          proxy_id:sessionStorage.getItem('proxy_id')
        },

        powerDialogForm: false,
        rulesPower: {
          name: [
            { required: true, message: '请输入角色', trigger: 'blur' },
            {
              min: 2,
              max: 5,
              message: "长度在 2 到 5 个字符",
              trigger: "blur",
            }
          ],
        },
        roleList: [],
        props:{value:'id',label:'name', multiple: true},
        role_id: '',
        powerForm: {
          name: '',
          url: '',
          module_id: '',
          AppListId:[],
          id:''
        },
        defaultProps: {
          children: 'children',
          label: 'name',
        },
        tenantUserId: [],
        tags: '',
        checked: false,
        idsArr: []


      };
    },
    created() {
      this.DataList()
    },
    mounted() {
    },
    filters: {
      statusFilter(status) {
        if (status == 0) {
          return "启用";
        } else if (status == 1) {
          return "禁用";
        }
      }
    },
    methods: {
      handleCheckChange(data, checked) {
        if(!checked){
          this.$confirm('此操作将删除该节点, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const param = {
              company_id:sessionStorage.getItem('company_id'),
              access_token:sessionStorage.getItem('token'),
              module_id:data.id,
              role_id:this.powerForm.id,
            }
            this.$axios.proxyRoleDelModule(param).then(res=>{
              if(res.code == 200){
                this.$message.success(res.msg);
              }else{
                this.$message.error(res.msg);
              }
            }).catch(error=>{
              console.log(error);
            })
          }).catch(() => {
            // 点击取消:不删除了
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        }
        let isCheck= this.$refs.tree.getCheckedKeys().includes(data.id);

        console.log('data---',data);
        console.log('checked---',checked);
        console.log('isCheck---',isCheck);

        this.tenantUserId = this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys())

      },
      DataList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          page: this.currentPage,
          pageSize: this.pageSize,
          proxy_id:sessionStorage.getItem('proxy_id'),
        }
        this.$axios.getProxyRoleList(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data
            //this.total = res.data.total
          }
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.currentPage = newPage
        this.DataList()
      },
      // 新增
      addData() {
        this.title = '新增'
        this.form.id='';
        this.id='';
        this.dialogFormVisible = true
      },
      handelEdit(row) {
        this.id = row.id
        this.title = '编辑'

        this.dialogFormVisible = true
        // this.form = {...row};
        // 或者
        this.form = JSON.parse(JSON.stringify(row))
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            console.log('this.form-----9999---',this.form)
            if(!this.id){
              const param = {
                name: this.form.name,
                remark: this.form.remark,
                status: this.form.status,
                proxy_id: this.form.proxy_id,
                company_id:sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token')
              }
              this.$axios.proxyRoleSave(param).then(res =>{
                if(res.code == 200){
                  this.DataList()
                  this.$message.success(res.msg)
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }else{
              const param = {
                id: this.form.id,
                name: this.form.name,
                status: this.form.status,
                remark: this.form.remark,
                proxy_id: this.form.proxy_id,
                company_id:sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token')
              }
              this.$axios.proxyRoleSave(param).then(res =>{
                if(res.code == 200){
                  this.$message.success(res.msg)
                  this.DataList()
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }

          }
        })
      },
      searchSubmit() {
        const param = {
          keyword: this.searchForm.name,
          status: this.searchForm.status,
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          page: this.currentPage,
          pageSize: this.pageSize
        }
        this.$refs.searchForRef.validate((valid) => {
          if (valid) {
            this.$axios.roleList(param).then(res=>{
              if(res.code == 200){
                this.tableLoadData = res.data.data
                this.total = res.data.total
              }
            })
          }
        })
      },
      handelDel(e) {
        console.log(e);
        this.$confirm('此操作将删除该角色, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.data.row.role_id,
          }
          this.$axios.roleDelModule(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });

        this.teamDialog = false
      },

      handelOpen(e) {
        this.$confirm('此操作将修改状态, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            id: e.data.row.role_id,
            status: 1,
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
          }
          this.$axios.roleChangeStatus(param).then(res =>{
            if(res.code == 200){
              this.DataList()
              this.$message.success(res.msg)
              this.statusDialog = false
            }else{
              this.$message.error(res.msg);
            }
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消修改状态'
          });
          this.DataList()
        });

      },
      handelColse(e) {
        this.$confirm('此操作将修改状态, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            id: e.data.row.role_id,
            status: 0,
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
          }
          this.$axios.roleChangeStatus(param).then(res =>{
            if(res.code == 200){
              this.DataList()
              this.$message.success(res.msg)
              this.statusDialog = false
            }else{
              this.$message.error(res.msg);
            }
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消修改状态'
          });
          this.DataList()
        });

      },

      handelSelect(row) {

        let _this=this;
        this.id = row.id;

        this.idsArr = row.id
        console.log('ids',this.idsArr)
        this.powerForm.id = row.id
        this.powerDialogForm = true
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          proxy_id:_this.form.proxy_id,
        }
        console.log('param------',param)
        this.$axios.proxyModuleFindTree(param).then(res=>{
          if(res.code == 200){
            var roleArr = [];
            (res.data).forEach(v  => {
              var con = {}; //二级内容
              var con_child=[]; //二级内容的child
              con.id = v.id;
              con.name = v.name;

              if(v.children != undefined ) {
                (v.children).forEach(v2  => {
                  var con2 = {}; //二级内容的child的内容
                  con2.id = v2.id;
                  con2.name = v2.name;

                  con_child.push(con2);
                })
                con.children = con_child;
              }
              roleArr.push(con);
            });
            this.roleList = roleArr;

            _this.getUserRoleTree(row.id);
          } //code=200
        })

      },
      getUserRoleTree(role_id){
        let _this=this;
        const param = {
          role_id: role_id,
          operator_id: sessionStorage.getItem('user_id'),
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          proxy_id: _this.form.proxy_id,
        }
        this.$axios.proxyRoleModuleList(param).then((res)=>{
          if(res.code==200){

            if(res.data){
              res.data.forEach (function (el) {
                _this.defaultCateIds.push(el.id);

              });
            }

            console.log('555-----',res)
            if(_this.defaultCateIds.length>0){
              _this.$refs.tree.setCheckedKeys(res.data);
            }

          }
          console.log(res);
        });
      },
      getRoleId(e) {
        console.log(e);

      },
      reset_powerForm(formName) {
        this.powerDialogForm = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      powerSubmitForm(formName) {
        let _this=this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const param = {
              id: this.id,
              module_ids: this.tenantUserId,
              company_id: sessionStorage.getItem('company_id'),
              access_token: sessionStorage.getItem('token'),
              proxy_id:_this.form.proxy_id
            }
            console.log(param,444);
            this.$axios.proxyRoleSetPower(param).then(res =>{
              if(res.code == 200){
                this.DataList()
                this.$message.success(res.msg)
                this.powerDialogForm = false
              }else{
                this.$message.error(res.msg);
              }
            })
          }
        })
      },

    },
  };
</script>
<style>
  /* .dialog-footer{
    border: 1px solid #f00;
  } */
</style>
